import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { vehicles } from '../utils/mockData';
import Meter from '../components/common/Meter';
import TelemetryIllustration from '../components/common/TelemetryIllustration';

const { FiMoreVertical, FiNavigation, FiCalendar, FiClipboard, FiZap } = FiIcons;

const VehicleCard = ({ vehicle, delay }) => {
  const isWarning = vehicle.status === 'warning' || vehicle.status === 'maintenance';
  const panelClass = isWarning ? 'hud-panel-warning' : vehicle.status === 'active' ? 'hud-panel-active' : 'hud-panel';
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className={`${panelClass} flex flex-col h-full overflow-hidden group`}
    >
      <div className="h-32 w-full p-4 bg-[#050508] border-b border-[#1a1a2e]">
        <TelemetryIllustration type={vehicle.type === 'Heavy Truck' ? 'engine' : 'map'} />
      </div>

      <div className="p-6 flex-1 flex flex-col">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h3 className="text-xl font-bold font-mono tracking-tighter text-white">{vehicle.id}</h3>
            <p className="text-[9px] text-gray-500 uppercase tracking-[0.2em] font-mono">{vehicle.type}</p>
          </div>
          <div className={`text-[9px] font-mono px-3 py-1 rounded-full border uppercase tracking-widest font-bold ${isWarning ? 'border-[#ff5500]/50 text-[#ff5500] bg-[#ff5500]/5' : vehicle.status === 'active' ? 'border-[#00f0ff]/50 text-[#00f0ff] bg-[#00f0ff]/5' : 'border-gray-700 text-gray-500 bg-gray-900'}`}>
            {vehicle.status}
          </div>
        </div>

        <div className="space-y-5 mb-8">
          <Meter value={vehicle.fuel} label="ENERGY_CORE" type={vehicle.fuel < 30 ? 'orange' : 'blue'} />
          <Meter value={vehicle.health} label="STRUCTURAL_INTEGRITY" type={vehicle.health < 50 ? 'orange' : 'blue'} />
        </div>

        <div className="mt-auto space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-[#050508] p-3 rounded-lg border border-[#1a1a2e]">
              <p className="text-[8px] font-mono text-gray-600 uppercase tracking-widest mb-1">Service_Log</p>
              <p className={`text-[10px] font-mono ${vehicle.nextService === 'IMMEDIATE' ? 'text-[#ff5500]' : 'text-gray-300'}`}>{vehicle.nextService}</p>
            </div>
            <div className="bg-[#050508] p-3 rounded-lg border border-[#1a1a2e]">
              <p className="text-[8px] font-mono text-gray-600 uppercase tracking-widest mb-1">Operator</p>
              <p className="text-[10px] font-mono text-gray-300 truncate">{vehicle.driver}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-[10px] font-mono text-gray-500 uppercase px-1">
            <SafeIcon icon={FiNavigation} className="text-[#00f0ff]" />
            <span className="truncate">{vehicle.location}</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const Vehicles = () => {
  const [filter, setFilter] = useState('all');
  const filteredVehicles = vehicles.filter(v => filter === 'all' ? true : v.status === filter);

  return (
    <div className="space-y-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
        <div className="space-y-1">
          <h1 className="text-3xl font-bold text-white tracking-tighter uppercase">Fleet <span className="text-[#00f0ff] text-glow-blue">Inventory</span></h1>
          <p className="text-xs font-mono text-gray-500 uppercase tracking-widest">Active Unit Telemetry & Maintenance Gates</p>
        </div>
        
        <div className="flex bg-[#0a0a12] p-1.5 rounded-xl border border-[#1a1a2e]">
          {['all', 'active', 'warning', 'idle'].map(f => (
            <button 
              key={f}
              onClick={() => setFilter(f)}
              className={`px-6 py-2 text-[10px] font-mono uppercase tracking-[0.2em] rounded-lg transition-all ${filter === f ? 'bg-[#00f0ff]/10 text-[#00f0ff] shadow-[0_0_15px_rgba(0,240,255,0.1)]' : 'text-gray-500 hover:text-gray-300'}`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        {filteredVehicles.map((vehicle, i) => (
          <VehicleCard key={vehicle.id} vehicle={vehicle} delay={i * 0.1} />
        ))}
      </div>
    </div>
  );
};

export default Vehicles;